import React, {useContext, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import * as Actions from '../../store/actions';
import {
  DashboardLayout,
  PrimaryButton,
  SecondaryButton,
} from '../../components';
import {PAGES_URL} from '../../helpers/constants';
import {PageContext} from '../../helpers/context';
import SingleAnalysisModal from './SingleAnalysisModal';
import {PerformBtn, ViewLink} from '../../components/lookupComponents';
import {DocumentAnalysis1} from './_DocumentAnalysisImage1';
import {DocumentAnalysis2} from './_DocumentAnalysisImage2';
import {getLighterShade} from 'routes/EasyOnboard/colorUtils';

function DocumentAnalysis({auth: {userDetails}}) {
  const [openSingleAnalysis, setOpenSA] = useState(false);
  const {setPageName} = useContext(PageContext);
  useEffect(() => {
    setPageName('document-analysis');
  }, [setPageName]);

  const isCompanyVerified = userDetails?.company?.verified;
  const baseColor = userDetails?.company?.color_code || '#3f7cdb';
  const lighterShade = getLighterShade(baseColor, 96);

  const performSingleAnalysis =
    userDetails?.permissions?.documentAnalysisPermissions?.performSingleLookup;

  const viewHistory =
    userDetails?.permissions?.documentAnalysisPermissions?.viewSingleLookup;

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Document Analysis</p>
      }
    >
      <SingleAnalysisModal open={openSingleAnalysis} setOpen={setOpenSA} />

      <div className="flex flex-col pt-10 sm:flex-row items-stretch gap-10 sm:gap-4 lg:gap-10">
        <div
          style={{
            backgroundColor: lighterShade,
            borderColor: 'rgba(230, 240, 255, 0.5)',
          }}
          className="rounded-xl pb-0 flex flex-col items-start sm:max-w-[406px] w-full border"
        >
          {' '}
          <div className="py-8 px-6 w-full">
            <h2 className="text-deepBlue mb-1 text-lg font-semibold">
              Perform Single Analysis
            </h2>
            <p className="text-[#8E90A9] w-full border tracking-[-0.01em] border-transparent text-base font-light">
              Verify your user identity with ease
            </p>
            <div className="w-full flex flex-col mt-8 lg:flex-row items-start lg:items-center gap-2">
              <PerformBtn
                setOpen={setOpenSA}
                permitted={performSingleAnalysis}
                isCompanyVerified={isCompanyVerified}
                btnText="Perform Single Analysis"
              />

              <ViewLink
                permitted={viewHistory}
                route={PAGES_URL.DOCUMENT_ANALYSIS_SINGLE}
              />
            </div>
          </div>
          <div className="mt-auto lg:mt-14 flex justify-center w-full">
            <DocumentAnalysis1 />
          </div>
        </div>

        <div
          style={{
            backgroundColor: lighterShade,
            borderColor: 'rgba(230, 240, 255, 0.5)',
          }}
          className="rounded-xl pb-0 flex flex-col items-start sm:max-w-[406px] w-full border"
        >
          {' '}
          <div className="py-8 px-6 w-full">
            <div className="rounded-t-xl flex mb-1 items-center gap-3 w-full border-transparent">
              <h2 className="text-deepBlue text-lg font-semibold">
                Perform Batch Analysis
              </h2>
              <div className=" px-1.5 p-1 text-[8px] font-medium uppercase rounded-full w-fit text-batchBlue bg-batchBlue20">
                soon
              </div>
            </div>
            <p className="text-[#8E90A9] w-full border tracking-[-0.01em] border-transparent text-base font-light">
              Upload and verify multiple users seamlessly
            </p>
            <div className="w-full flex flex-col mt-8 lg:flex-row items-start lg:items-center gap-2">
              <PrimaryButton
                disabled={true}
                buttonText="Perform Batch Analysis"
                className="!h-10"
              />
              <SecondaryButton
                to={PAGES_URL.DOCUMENT_ANALYSIS_BATCH}
                buttonText="View History"
                disabled={true}
                className="!h-10"
              />
            </div>
          </div>
          <div className="mt-14 flex justify-center w-full opacity-70">
            <DocumentAnalysis2 />
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default connect(state => state, Actions)(DocumentAnalysis);
